import type {
	PensionProductsDetailDataDTO,
	PortfolioDetailResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { parseIsoDate } from "web_myplann/Portfolio/Forms/dateParsers";
import { PENSION_FORM_DEFAULT_VALUES as DEFAULTS } from "web_myplann/Portfolio/Forms/PensionForm/pensionFormDefaults";
import type { PensionFormInput } from "web_myplann/Portfolio/Forms/PensionForm/pensionFormSchema";

export const mapPortfolioToPensionForm = (
	portfolio: PortfolioDetailResponseDTO,
): PensionFormInput => {
	const data = portfolio.data as PensionProductsDetailDataDTO | undefined;
	return {
		name: portfolio.name ?? DEFAULTS.name,
		contractNumber: portfolio.contractNumber ?? DEFAULTS.contractNumber,
		producer: portfolio.producer ?? DEFAULTS.producer,
		product: portfolio.product ?? DEFAULTS.product,
		productCategoryId:
			portfolio.productCategoryId ?? DEFAULTS.productCategoryId,
		signedAt: parseIsoDate(portfolio.signedAt),
		startAt: parseIsoDate(portfolio.startAt),
		endAt: parseIsoDate(portfolio.endAt),
		payment: data?.payment ?? DEFAULTS.payment,
		paymentFrequency: data?.paymentFrequency ?? DEFAULTS.paymentFrequency,
	};
};
